import React from 'react';
import { NavLink, Outlet, useNavigate, Navigate } from 'react-router-dom';
import { LayoutDashboard, Inbox, FileText, Users, Newspaper, Award, LogOut, KeyRound } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';

const navItems = [
  { to: '/admin', label: 'Dashboard', icon: LayoutDashboard, end: true },
  { to: '/admin/enquiries', label: 'Enquiries', icon: Inbox },
  { to: '/admin/content', label: 'Content', icon: FileText },
  { to: '/admin/team', label: 'Team', icon: Users },
  { to: '/admin/articles', label: 'Articles', icon: Newspaper },
  { to: '/admin/case-studies', label: 'Case Studies', icon: Award },
];

export default function AdminLayout() {
  const { user, logout, loading } = useAuth();
  const nav = useNavigate();

  if (loading) return <div className="min-h-screen bg-forest-950 flex items-center justify-center text-cream-100">Loading...</div>;
  if (!user) return <Navigate to="/admin/login" replace />;
  if (user.must_change_password && window.location.pathname !== '/admin/change-password') {
    return <Navigate to="/admin/change-password" replace />;
  }

  return (
    <div className="min-h-screen bg-forest-950 flex">
      <aside className="w-64 bg-forest-900 border-r border-forest-800 flex flex-col">
        <div className="p-6 border-b border-forest-800">
          <p className="font-serif text-cream-50 text-xl leading-tight">Perrin Myddelton</p>
          <p className="text-cream-100/50 text-xs mt-1 tracking-widest uppercase">CMS Console</p>
        </div>
        <nav className="flex-1 p-3 space-y-1">
          {navItems.map(({ to, label, icon: Icon, end }) => (
            <NavLink key={to} to={to} end={end} className={({ isActive }) => `flex items-center gap-3 px-4 py-2.5 text-sm transition-colors ${isActive ? 'bg-sage-500/15 text-sage-400' : 'text-cream-100/80 hover:bg-forest-800 hover:text-cream-50'}`}>
              <Icon className="h-4 w-4" /> {label}
            </NavLink>
          ))}
        </nav>
        <div className="p-3 border-t border-forest-800 space-y-1">
          <button onClick={() => nav('/admin/change-password')} className="w-full flex items-center gap-3 px-4 py-2.5 text-sm text-cream-100/80 hover:bg-forest-800 hover:text-cream-50 transition-colors"><KeyRound className="h-4 w-4" />Change Password</button>
          <button onClick={() => { logout(); nav('/admin/login'); }} className="w-full flex items-center gap-3 px-4 py-2.5 text-sm text-cream-100/80 hover:bg-forest-800 hover:text-cream-50 transition-colors"><LogOut className="h-4 w-4" />Sign Out</button>
          <div className="px-4 py-2 text-xs text-cream-100/45">Signed in as <span className="text-cream-100/80">{user.username}</span></div>
        </div>
      </aside>
      <main className="flex-1 p-8 overflow-y-auto"><Outlet /></main>
    </div>
  );
}
